import React, { useRef } from 'react';
import ScrollContext from './scroll-context';

type Props = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> & {
  scrollMode?: 'auto' | 'disabled';
  onContentSizeChange?: (width: number, _height: number) => void; // used only in native version of container
};

export default function ScrollContainer({
  scrollMode = 'auto',
  ...props
}: Props) {
  const { current: context } = useRef({ scrollMode, anchors: [] });
  return (
    <ScrollContext.Provider value={context}>
      <div {...props} />
    </ScrollContext.Provider>
  );
}
